
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/search",
      function () {
        return require("private-next-pages/[region]/search.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/search"])
      });
    }
  